/**
 * Releases modal state left behind by third-party upsell dialogs after the
 * native Shopify cart drawer closes.
 */
window.addEventListener('hana:cart-drawer-closed', () => {
  window.setTimeout(() => {
    document.querySelectorAll('dialog[open]').forEach((dialog) => {
      dialog.close();
    });

    document.querySelectorAll('.essential-upsell-popup-overlay').forEach((overlay) => {
      overlay.remove();
    });

    document.body.classList.remove('overflow-hidden');
    document.documentElement.style.removeProperty('overflow');
    window.dispatchEvent(new CustomEvent('theme:scroll:unlock'));
  }, 350);
});
